"use client";

import { notFound } from "next/navigation";
import { toolsRegistry } from "@/contexts/ToolsContext";
import EditorV2Shell from "@/app/editor-v2/_components/EditorV2Shell";
import {
  PHOTO_EDITOR_REGISTRY_TOOL_ID,
  getPhotoEditorTool,
} from "@/app/editor/data/ai-photo-editor";

export default function PhotoEditorPresetPage({ params }: { params: { presetId: string } }) {
  const catalogTool = getPhotoEditorTool(params.presetId);
  const toolInfo = toolsRegistry.find((t) => t.id === PHOTO_EDITOR_REGISTRY_TOOL_ID);

  if (!catalogTool || !toolInfo) {
    notFound();
  }

  return (
    <EditorV2Shell
      toolInfo={toolInfo}
      title={catalogTool.title}
      catalogToolId={catalogTool.id}
    />
  );
}
